import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { HistoryStore, ObjectHistory } from '@iotv/datamodel';
import { useMemo, useState } from 'react';
import ObjectHistoryTableCard from '../../generic/ObjectHistoryTableCard';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ObjectHistoryTableCardWidget = (props) => {
    const [objectHistory] = useState(new ObjectHistory({ type: 'Customer', recentStateHistory: new HistoryStore() }));
    const component = useMemo(() => props.contextCustomer ? (_jsx(ObjectHistoryTableCard, { contextCustomer: props.contextCustomer, viewDefinition: {}, transactionFunctions: props.transactionFunctions, viewObject: {
            matchedPrimary: props.contextCustomer,
            matchedRelatedByPk: undefined,
            matchedRelatedBySk: undefined,
            largeObject: undefined,
        }, contextObject: props.contextObject, userFunctions: props.userFunctions, objectHistory: objectHistory, userSelectedGroup: props.userSelectedGroup })) : (_jsx(_Fragment, {})), [props.contextCustomer, objectHistory]);
    return {
        name: 'ObjectHistoryTableCard',
        category: 'generic',
        component,
    };
};
